import { IMAGE_RATIO, ImageRatioValues } from 'defs/assets';
import { ImageDtoType } from 'types/services/magnolia/dtos/ImageDto';
import { LOAD_ASSET, LOAD_ASSET_SUCCESS } from './assets.actionTypes';

export const actionCreators = {
	doLoadAsset: (path: string, ratio: ImageRatioValues = IMAGE_RATIO.R1_1 as any) => ({
		type: LOAD_ASSET,
		path,
		ratio,
	}),
	doLoadAssetSuccess: (path: string, model: ImageDtoType, ratio: ImageRatioValues) => ({
		type: LOAD_ASSET_SUCCESS,
		path,
		model,
		ratio,
	}),
};

export type AssetsActionType =
	| ReturnType<typeof actionCreators.doLoadAsset>
	| ReturnType<typeof actionCreators.doLoadAssetSuccess>;
